import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationUtilityService {

  constructor() { }

  public isApplicationLocked(statusId: number, stageId: number): boolean {
    const ApplicationAcceptedStatusID = 3;
    const ApplicationCompleteStageId = 10;
    const ApplicationNoResponseStageId = 11;
    return statusId == ApplicationAcceptedStatusID && (stageId == ApplicationCompleteStageId || stageId == ApplicationNoResponseStageId);
  }
}
